import type { Root } from './prototypeTypes';

export const VISITOR_CATALOG_CTA_HEADLINE = 'A growing library of topics';

export function visitorCatalogCtaMarkup(instance: 'browse' | 'home', extraClass = ''): string {
	const className = ['visitor-browse-cta', extraClass.trim()].filter(Boolean).join(' ');
	return String.raw`<div class="${className}" data-visitor-catalog-cta data-cta-instance="${instance}" data-visitor-only="true">
        <div class="visitor-browse-cta-inner">
          <span class="visitor-browse-cta-icon" aria-hidden="true">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path>
              <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>
            </svg>
          </span>
          <div class="visitor-browse-cta-text">
            <strong data-role="headline">${VISITOR_CATALOG_CTA_HEADLINE}</strong>
            <span data-role="subline">Preview any topic now. Create a free account to save topics and keep your progress across devices.</span>
          </div>
          <div class="visitor-browse-cta-actions">
            <button class="btn-primary" data-role="register" data-proto-click="showRegisterModal()">
              Sign up free
            </button>
            <button class="btn-secondary" data-role="login" data-proto-click="showLoginModal()">
              Log in
            </button>
          </div>
        </div>
      </div>`;
}

export function getRuntimePlan(root: Root): string {
	const prototypeState = (root as unknown as {
		__prototypeState?: { runtime?: { currentPlan?: string }; currentPlan?: string };
	}).__prototypeState;
	return prototypeState?.runtime?.currentPlan ?? prototypeState?.currentPlan ?? 'visitor';
}

function findVisitorCatalogCta(root: Root, instance: 'browse' | 'home'): HTMLElement | null {
	const selector = `[data-visitor-catalog-cta][data-cta-instance="${instance}"]`;
	const candidate = root as Root & { matches?: (selectors: string) => boolean };
	if (candidate.matches?.(selector)) return candidate as HTMLElement;
	return root.querySelector<HTMLElement>(selector);
}

export function applyVisitorCatalogCta(root: Root, instance: 'browse' | 'home', _totalTopics: number): void {
	const host = findVisitorCatalogCta(root, instance);
	if (!host) return;
	if (getRuntimePlan(root) !== 'visitor') {
		host.style.display = 'none';
		return;
	}
	host.style.display = 'block';
	const headline = host.querySelector<HTMLElement>('[data-role="headline"]');
	if (!headline) return;
	headline.textContent = VISITOR_CATALOG_CTA_HEADLINE;
}

/** Immediately removes visitor-only conversion UI after authentication. This
 * deliberately does not wait for the active view's follow-up network refresh. */
export function hideVisitorCatalogCtas(root: Root): void {
	root.querySelectorAll<HTMLElement>('[data-visitor-catalog-cta][data-visitor-only="true"]').forEach((host) => { host.style.display = 'none'; });
}
